import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export function getFullDateFormat(date: string) {
	dayjs.extend(utc);
	const dayjsUtc = dayjs.utc(date);
	const localDate = dayjsUtc.local().format();
	const day = dayjs(localDate).date();
	// month is from 0 to 11
	const month = dayjs(localDate).month() + 1;
	const sanitizedMonth = month < 10 ? "0" + String(month) : month;
	const hour = dayjs(localDate).hour();
	const sanitizedHour = hour < 10 ? `0${hour}` : hour;
	const minute = dayjs(localDate).minute();
	const sanitizedMinute = minute < 10 ? `0${minute}` : minute;
	return `${day}/${sanitizedMonth} (${sanitizedHour}:${sanitizedMinute})`;
}
